import { useEffect } from "react";

export const SITE_URL = "https://www.phudg.in";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const Seo = ({ title, description, image, path, noindex = false }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const pathname = path || window.location.pathname;
    const url = origin + pathname;
    const img = image ? (image.startsWith("http") ? image : origin + image) : `${origin}/images/hero-table.jpg`;
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    setMeta("property", "og:title", title || "");
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:image", img);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "PhudG");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title || "");
    setMeta("name", "twitter:description", description || "");
    setMeta("name", "twitter:image", img);
    setLink("canonical", SITE_URL + pathname);
    if (noindex) setMeta("name", "robots", "noindex, nofollow");
  }, [title, description, image, path, noindex]);
  return null;
};
